<template>
  <card-item card="item_group" :isFull="true" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys" />
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key: 'information_card',
          component: () => import("./Info"),
        },
        {
          title: "Ученики",
          component: () => import("./GroupClient"),
          key: 'pupils_card',
        },
        {
          title: "Разделение  на группы",
          component: () => import("./GroupDivision"),
          key: 'division_group',
        },
        {
          title: "Учителя",
          component: () => import("./GroupCustomer"),
          key: 'teachers_card',
        },
        {
          title: "Расписание",
          component: () => import("./TimetableEdit"),
          key: 'schedule_card',
        },
      ],
      activeTab: 0,
      infoKeys: [
        {
          key: 'title',

          title: 'Класс'
        },
      ]
    };
  },
};
</script>